import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";

import MaterialBox from "../../../../components/MaterialBox";
import {
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "../../../../context";
import { navbarContainer, navbar, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import {
  Avatar,
  Badge,
  Box,
  colors,
  InputBase,
  MenuItem,
  Typography,
} from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import FilterListIcon from "@mui/icons-material/FilterList";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SearchIcon from "@mui/icons-material/Search";
import UploadIcon from "@mui/icons-material/Upload";
import { UserContext } from "../../../../pages/usercontext/usercontext";
import MessagePopup from "../../../../pages/Utils/MessagePopup";
import AccessComponent from "../../../../pages/Utils/AccessComponent";

function DashboardNavbar({
  absolute,
  light,
  isMini,
  UserLogout,
  Logout,
  searchdata,
  setsearchdata,
  setOpenExport,
  setOpenFilter,
  name,
}) {
  // const { user } = useContext(UserContext);

  const { isuser } = useContext(UserContext);

  const { pathname } = useLocation();
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } =
    controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [noSearch, setNoSearch] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const [user, setUser] = useState({
    name: "",
    picture: "",
    email: "",
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });
  const [pageState, setPageState] = useState({
    state: "init",
  });
  useEffect(() => {
    const getUser = () => {
      setUser({
        name: user.name,
        email: user.email,
        picture: user.picture,
      });
      setPageState({
        state: "default",
      });
    };
    getUser();
  }, []);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const navigate = useNavigate();
  const open = Boolean(openMenu);
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={
          <>
            {user.picture ? (
              <Avatar
                alt={
                  isuser?.username || user?.name || user?.roleName || "UNNAMED"
                }
                src={user.picture}
                sx={{ width: 24, height: 24 }}
              />
            ) : (
              <MaterialAvatar
                size="sm"
                {...stringAvatar(
                  user.name ||
                    user?.email ||
                    user?.roleName ||
                    isuser?.username ||
                    "UNNAMED"
                )}
              />
            )}
          </>
        }
        title={user?.roleName || isuser?.username || user?.email}
      />
      <NotificationItem
        id="logout"
        onClick={signOut}
        icon={<LogoutIcon />}
        title={"Logout"}
      />
    </Menu>
  );

  const signOut = async () => {
    const refreshToken = sessionStorage.getItem("refreshToken");
    const variables = {
      refreshToken,
    };
    try {
      const response = await Logout(UserLogout, { input: variables });
      if (response?.logout?.success === true) {
        setPopup({
          open: true,
          message: "Logout Successfully",
          severity: "success",
        });
        setTimeout(() => {
          navigate("sign-in");
        }, 1000);
        sessionStorage.clear();
      } else {
        setPopup({
          open: true,
          message: response?.logout?.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
    }
    // navigate("/");
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    // try {

    //   await fetchData("auth/logout");
    //   navigate("/login");
    // } catch (error) {
    //   console.error("Logout failed", error);
    // }
  };
  const handleSearch = (event) => {
    setsearchdata(event.target.value);
  };

  const exportOpen = () => {
    setOpenExport(true);
  };

  const filterOpen = () => {
    setOpenFilter(true);
  };
  return (
    <AppBar
      // position={absolute ? "absolute" : navbarType}
      position="relative"
      // position="navbarType"
      // color="inherit"
      // sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      {/* <Toolbar sx={(theme) => navbarContainer(theme)}>
        {
          pageState.state === 'default' && (
            <>
              <MaterialBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}  >
                <MaterialBox display="flex" >
                  <Icon fontSize="medium" onClick={handleMiniSidenav} sx={{ cursor: "pointer" }}>
                    {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                  </Icon>
                  <MaterialBox ml={1}>
                    <Breadcrumbs icon={<HomeIcon />} title={route[route.length - 1]} route={route} light={light} />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
              {isMini ? null : (
                <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                  <IconButton
                    onClick={handleOpenMenu}
                    size="small"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                  >
                    <MaterialAvatar alt={user.name} src={user.picture} sx={{ width: 35, height: 35 }} />
                  </IconButton>
                  {renderMenu()}
                </MaterialBox>
              )}
            </>
          )
        }
      </Toolbar> */}

      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left Section */}
        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ display: "flex", gap: 3, mt: 4 }}>
            <Icon
              fontSize="medium"
              onClick={handleMiniSidenav}
              sx={{ cursor: "pointer" }}
            >
              {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
            </Icon>
            <Typography
              variant="h4"
              sx={{ color: "#000", fontWeight: "bold", mt: -0.4, textTransform: "capitalize" }}
            >
              Welcome Back, {isuser?.username}
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ mt: 1, color: "#000", ml: -1 }}>
            <IconButton sx={{ mt: -0.6, color: "#000" }}>
              <HomeIcon />
            </IconButton>{" "}
            / {route[route.length - 1]}
          </Typography>
        </Box>
        {/* Right Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 3,
            flexGrow: 1,
            pr: 4,
            mt: -2,
          }}
        >
          {/* Search Bar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              borderRadius: "50px",
              padding: "4px 12px",
              width: "100%",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              "&:hover": {
                borderColor: "#D0D0D0",
              },
            }}
          >
            <SearchIcon sx={{ color: "#8A8A8A" }} />
            <InputBase
              placeholder="Search"
              onChange={handleSearch}
              value={searchdata}
              sx={{
                ml: 2,
                flex: 1,
                fontSize: "16px",
                color: "white",
                borderWidth: 0,
                backgroundColor: "white",
                padding: "5px",
              }}
            />
          </Box>

          {/* Icons */}
          {(pathname === "/dashboard" ||
            pathname === "/Hiring-Process/shortlist" ||
            pathname === "/Hiring-Process/interviewed" ||
            pathname === "/Hiring-Process/onboarded") && (
            <IconButton onClick={filterOpen}>
              <FilterListIcon sx={{ color: "#000" }} />
            </IconButton>
          )}

          {/* {(pathname === "/dashboard" ||
            pathname === "/master/client" ||
            pathname === "/master/position" ||
            pathname === "/master/user" ||
            pathname === "/Hiring-Process/hiring-queue" ||
            pathname === "/Hiring-Process/invoice") && ( */}
          <AccessComponent name={name} action="Export">
            <IconButton onClick={exportOpen} title={"Export"}>
              <svg
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9 4.328V15.5H7V4.328L3.757 7.571L2.343 6.157L8 0.5L13.657 6.157L12.243 7.571L9 4.328ZM0 14.5H2V18.5H14V14.5H16V18.5C16 19.6 15.1 20.5 14 20.5H2C0.9 20.5 0 19.537 0 18.5V14.5Z"
                  fill="black"
                />
              </svg>
            </IconButton>
          </AccessComponent>
          {/* )} */}

          <IconButton
            title={"Activity Log"}
            onClick={() => {
              navigate("/activityLog");
            }}
          >
            <svg
              width="41"
              height="41"
              viewBox="0 0 41 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="41" height="41" rx="20.5" fill="white" />
              <path
                d="M21 15.3936C20.8342 15.3936 20.6753 15.4594 20.5581 15.5766C20.4408 15.6938 20.375 15.8528 20.375 16.0186V21.4686L24.0625 23.9686C24.2009 24.0565 24.3683 24.0865 24.5286 24.0521C24.689 24.0177 24.8293 23.9217 24.9195 23.7848C25.0097 23.6478 25.0425 23.481 25.0108 23.3201C24.9791 23.1592 24.8854 23.0173 24.75 22.9248L21.625 20.8061V16.0186C21.625 15.8528 21.5592 15.6938 21.4419 15.5766C21.3247 15.4594 21.1658 15.3936 21 15.3936Z"
                fill="black"
              />
              <path
                d="M21 10.5C19.2145 10.5063 17.4629 10.9878 15.9251 11.895C14.3874 12.8023 13.1189 14.1027 12.25 15.6625V12.5C12.25 12.3342 12.1842 12.1753 12.0669 12.0581C11.9497 11.9408 11.7908 11.875 11.625 11.875C11.4592 11.875 11.3003 11.9408 11.1831 12.0581C11.0658 12.1753 11 12.3342 11 12.5V18H16.5C16.6658 18 16.8247 17.9342 16.9419 17.8169C17.0592 17.6997 17.125 17.5408 17.125 17.375C17.125 17.2092 17.0592 17.0503 16.9419 16.9331C16.8247 16.8158 16.6658 16.75 16.5 16.75H13.0938C13.882 15.0864 15.1749 13.7137 16.7885 12.8275C18.402 11.9412 20.254 11.5864 22.0808 11.8136C23.9077 12.0407 25.6164 12.8383 26.9637 14.0928C28.311 15.3473 29.2283 16.9948 29.5851 18.8009C29.9419 20.6069 29.72 22.4794 28.9509 24.152C28.1819 25.8246 26.9049 27.212 25.3016 28.1169C23.6984 29.0217 21.8506 29.3978 20.0213 29.1916C18.1919 28.9855 16.4742 28.2076 15.1125 26.9688C15.0518 26.9133 14.9807 26.8705 14.9034 26.8425C14.8261 26.8146 14.744 26.8021 14.6619 26.8059C14.5798 26.8097 14.4992 26.8296 14.4248 26.8645C14.3503 26.8994 14.2835 26.9486 14.2281 27.0094C14.1727 27.0701 14.1298 27.1412 14.1019 27.2185C14.0739 27.2958 14.0615 27.3779 14.0653 27.46C14.069 27.5421 14.089 27.6227 14.1239 27.6971C14.1588 27.7715 14.208 27.8383 14.2687 27.8937C15.4701 28.9877 16.9199 29.7725 18.4928 30.1801C20.0656 30.5878 21.7141 30.6061 23.2956 30.2334C24.8771 29.8606 26.3439 29.1082 27.5692 28.0411C28.7945 26.974 29.7413 25.6244 30.3277 24.1091C30.9141 22.5938 31.1225 20.9584 30.9347 19.3445C30.747 17.7306 30.1688 16.1867 29.2502 14.8465C28.3316 13.5062 27.1003 12.41 25.6627 11.6527C24.2252 10.8954 22.6248 10.4997 21 10.5Z"
                fill="black"
              />
            </svg>
          </IconButton>

          {/* <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "50%",
              boxShadow: 2, // Material-UI shorthand for elevation
              display: "flex", // Centering IconButton
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton>
              <Badge badgeContent={1} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Box> */}
          {isMini ? null : (
            <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
              <IconButton
                onClick={handleOpenMenu}
                size="small"
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MaterialAvatar
                  alt={user.name}
                  src={user.picture}
                  sx={{ width: 50, height: 50 }}
                  {...stringAvatar(
                    user.name ||
                      user?.email ||
                      user?.roleName ||
                      isuser?.username ||
                      "UNNAMED"
                  )}
                />
              </IconButton>
              {renderMenu()}
            </MaterialBox>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
